import { render } from "./TopBottomGPA.vue?vue&type=template&id=70445e99&scoped=true"
import script from "./TopBottomGPA.vue?vue&type=script&lang=js"
export * from "./TopBottomGPA.vue?vue&type=script&lang=js"

import "./TopBottomGPA.vue?vue&type=style&index=0&id=70445e99&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-70445e99"

export default script